import { render, staticRenderFns } from "./PracticalInfo.vue?vue&type=template&id=2f211df4&scoped=true&"
import script from "./PracticalInfo.vue?vue&type=script&lang=js&"
export * from "./PracticalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PracticalInfo.vue?vue&type=style&index=0&id=2f211df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f211df4",
  null
  
)

export default component.exports